import BaseFeature from '../../foundation/base/base';

export default class Breadcrumbs extends BaseFeature {
	constructor(element) {
		super(element);

		this.el = element;
		this.breadcrumbsItem = this.el.querySelectorAll('[data-ref="breadcrumbs__item"]');

		this.removeEmptyLinks();
	}

	removeEmptyLinks() {
		if (this.breadcrumbsItem) {
			Array.prototype.slice.call(this.breadcrumbsItem).forEach((item) => {
				const itemText = item.querySelector('[data-ref="breadcrumbs__item-text"]');

				if (!itemText.innerText) {
					item.remove();
				}
			});
		}
	}
}
